import {Helmet} from "react-helmet";
import React from "react";
import logo from "../../../../assets/images/logo.png";
import './PrivacyPolicy.scss';


const PrivacyPolicy = () => {

  return (
    <>
      <Helmet>
        <title>Política de Privacidade</title>
      </Helmet>
      <div className="PrivacyPolicy">
        <div className="navbar">
          <img src={logo} alt="Logo" style={{ height: '100%' }} />
        </div>

        <div className="content">
          <h1 className={"header"}>Política de Privacidade</h1>
          <>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>1 - INTRODUÇÃO</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAPTICKETS</strong> pessoa jurídica de direito privado,
              devidamente inscrita no CNPJ/MF sob nº 176.195.240-001/68, com sede na
              Rua Professor José Soares de Mello, 179 - Jardim Centenario, São Paulo - SP, 02882-100,
              <strong> </strong>doravante denominada apenas
              <strong> CLAP, </strong>está empenhada em proteger os Dados Pessoais
              tratados em suas atividades. Para cumprir com os princípios e requisitos
              determinados na Lei nº 13.709/2018 - Lei Geral de Proteção de Dados Pessoais
              -LGPD, implementou um programa de privacidade e governança de dados
              abrangente.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Esta Política de Privacidade tem por objetivo informar aos USUÁRIOS de
              nossos sites e aplicativos sobre o tratamento dos seus Dados Pessoais.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>2 – DEFINIÇÕES IMPORTANTES</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              •<span style={{ width: "29.92pt", display: "inline-block" }}>&nbsp;</span>
              “Dados Pessoais” são quaisquer informações pessoais relacionadas com uma
              pessoa que possa ser identificada, direta ou indiretamente, por referência a
              essas informações, tais como seu nome, endereço, RG, CPF, e-mail, telefone,
              dados de cartão de créditos, dados bancários, dentre outros.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              •<span style={{ width: "29.92pt", display: "inline-block" }}>&nbsp;</span>
              “Tratamento” significa qualquer operação ou conjunto de operações que seja
              realizado em dados pessoais, como a coleta, armazenamento, organização,
              estruturação, conservação, alteração, recuperação, consulta, utilização,
              divulgação, compartilhamento, exclusão ou destruição.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              •<span style={{ width: "29.92pt", display: "inline-block" }}>&nbsp;</span>
              “Dados Sensíveis” são tipos de dados pessoais que podem demonstrar a raça,
              etnia, opiniões políticas, crenças religiosas ou filosóficas, adesão a um
              sindicato, vida sexual ou orientação sexual, dados sobre a saúde e quaisquer
              dados genéticos ou biométricos de uma pessoa.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Esta Política se destina a você, <strong>Usuário</strong>, que de alguma
              forma acessou um site ou aplicativo da <strong>CLAP</strong>.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>3 - QUEM É O CONTROLADOR DOS SEUS DADOS PESSOAIS?</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP </strong>é a Controladora dos seus Dados Pessoais tratados a
              partir do seu acesso e utilização do site ou aplicativo. Segundo a LGPD,
              compete ao Controlador dos dados tomar as decisões sobre o tratamento dos
              Dados Pessoais.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>4 - QUAIS SÃO OS DADOS PESSOAIS TRATADOS PELA CLAP?</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Conforme estabelecido pela LGPD, qualquer informação relacionada a uma
              pessoa natural que a identifique ou que a tornem identificável é considerada
              Dado Pessoal. A seguir, estão listados os Dados Pessoais tratados pela{" "}
              <strong>CLAP</strong> a partir do seu acesso ao Website:
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <table
              cellSpacing={0}
              cellPadding={0}
              style={{ border: "0.75pt solid #000000", borderCollapse: "collapse" }}
            >
              <tbody>
              <tr style={{ height: "30pt" }}>
                <td
                  style={{
                    width: "111.2pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    <strong>Meio de Coleta</strong>
                  </p>
                </td>
                <td
                  style={{
                    width: "70.2pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    <strong>Dado</strong>
                    <strong>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    </strong>
                  </p>
                </td>
                <td
                  style={{
                    width: "88.2pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    <strong>Motivo para a coleta do dado</strong>
                    <strong>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    </strong>
                  </p>
                </td>
                <td
                  style={{
                    width: "114.2pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    <strong>Hipótese legal de tratamento</strong>
                    <strong>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    </strong>
                  </p>
                </td>
              </tr>
              <tr style={{ height: "25.5pt" }}>
                <td
                  rowSpan={8}
                  style={{
                    width: "111.2pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "0.75pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    Site ou aplicativo
                  </p>
                </td>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
                <td
                  rowSpan={8}
                  style={{
                    width: "88.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    Possibilitar ao usuário realizar a aquisição de produtos e serviços
                    oferecidos através do site, aplicativos ou plataformas da CLAP
                  </p>
                </td>
                <td
                  rowSpan={8}
                  style={{
                    width: "114.2pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "0.75pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    (i) Consentimento; (ii) cumprimento de contrato (após a inclusão dos
                    dados pelo cliente); (iii) Cumprimento de obrigação legal ou
                    regulatória
                  </p>
                </td>
              </tr>
              <tr style={{ height: "15pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              <tr style={{ height: "15pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              <tr style={{ height: "25.5pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              <tr style={{ height: "15pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              <tr style={{ height: "15pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              <tr style={{ height: "15pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderStyle: "solid",
                    borderWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              <tr style={{ height: "15pt" }}>
                <td
                  style={{
                    width: "70.2pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "0.75pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top"
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "11pt"
                    }}
                  >
                    &nbsp;
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>4.1 -</strong> A <strong>CLAP</strong> utiliza Cookies e
              identificadores anônimos para controle de audiência, navegação, segurança e
              publicidade, sendo que o USUÁRIO concorda com essa utilização ao aceitar
              essa Política de Privacidade. Os Cookies utilizados pela{" "}
              <strong>CLAP</strong> podem ser classificados de diversas formas:
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>(i) - Quanto à validade:</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>a) -</strong> <strong>De Sessão:</strong> são temporários e
              permanecem até que a página web ou o navegador sejam fechados. Podem ser
              utilizados em e-commerce, (para o USUÁRIO continuar navegando e não perder o
              que colocou no carrinho, por exemplo), para analisar padrões de tráfego na
              internet e para proporcionar melhor experiência e conteúdo contextualizado
              aos USUÁRIOS.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>b) -</strong> <strong>Permanente:</strong> persistem mesmo que o
              navegador tenha sido fechado. Podem ser utilizados, por exemplo, para
              lembrar informações de login e senha dos USUÁRIOS, ou para garantir uma
              melhor experiência ao USUÁRIO entre diferentes sessões.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>(ii) - Quanto à propriedade:</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>a) -</strong> <strong>Próprios:</strong> são de titularidade da{" "}
              <strong>CLAP</strong>, que possui total controle sobre seus cookies.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>b)</strong> - <strong>De Terceiros</strong>: são de titularidades de
              terceiros, mas incluídos no dispositivo dos USUÁRIOS mediante os sites,
              aplicativos e serviços oferecidos pela <strong>CLAP</strong>.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>(iii) - Quanto à finalidade:</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>a) </strong>- <strong>Estritamente necessários:</strong> essenciais
              para permitir ao USUÁRIO utilizar os sites, aplicativos e serviços
              oferecidos pela <strong>CLAP</strong>, os quais não poderiam ser
              corretamente oferecidos sem esses Cookies. São geralmente de Sessão e
              Próprios.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>b)</strong> - <strong>De performance:</strong> coletam informações
              anônimas sobre como os USUÁRIOS utilizam e interagem com os sites,
              aplicativos e serviços oferecidos pela <strong>CLAP</strong>, permitindo
              reconhecer seus perfis e contabilizar as visitas e interações. São
              geralmente próprios.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>c)</strong> - <strong>De funcionalidade: </strong>permitem à{" "}
              <strong>CLAP</strong> lembrar escolhas feitas pelos USUÁRIOS, tais como
              login e localização, e proporcionam experiências mais pessoais, além de
              possibilitar eventuais customizações, quando estiverem disponíveis. Essas
              informações podem ser anonimizadas transformando-se em Dados Anonimizados e
              não rastreiam atividades fora dos sites, aplicativos e serviços oferecidos
              pela <strong>CLAP</strong>. São geralmente Próprios e Permanentes.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>d)</strong> - <strong>De mídias sociais:</strong> permitem ao
              USUÁRIO se conectar com mídias sociais, tais como LinkedIn, Twitter,
              Facebook, Pinterest, Instagram e outros. São geralmente permanentes e de
              Terceiros.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>e)</strong> - <strong>De segurança:</strong> ajudam a{" "}
              <strong>CLAP</strong> a monitorar atividades fraudulentas e proteger os
              dados do usuário em acesso não autorizados. São geralmente permanentes e de
              Terceiros.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>4.2</strong> - O USUÁRIO pode não aceitar os Cookies para utilizar
              os sites, aplicativos e serviços oferecidos pela <strong>CLAP</strong>, mas
              nestas situações a <strong>CLAP</strong> não pode garantir o correto
              funcionamento de seu site. Os Cookies podem ser aceitos, excluídos ou
              rejeitados por meio de ferramentas de gerenciamento do próprio navegador
              usado pelo USUÁRIO.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>5 - COM QUEM COMPARTILHAMOS OS SEUS DADOS PESSOAIS?</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Os seus Dados Pessoais são tratados pela <strong>CLAP</strong> e seus
              Colaboradores. Dessa forma, apenas pessoas autorizadas pela{" "}
              <strong>CLAP</strong> podem acessar seus Dados Pessoais quando for
              estritamente necessário para as finalidades acima listadas ou para o
              cumprimento de obrigações legais e regulatórias.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP</strong>também poderá compartilhar os seus Dados Pessoais
              com:
            </p>
            <ol
              type="i"
              className="awlist1"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "28.35pt",
                  textIndent: "-14.15pt",
                  textAlign: "justify",
                  fontWeight: "bold",
                  listStylePosition: "inside"
                }}
              >
      <span
        style={{
          width: "5.79pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;&nbsp;&nbsp;{" "}
      </span>
                <span style={{ fontWeight: "normal" }}>Parceiros comerciais;</span>
              </li>
            </ol>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "28.35pt",
                marginBottom: "0pt",
                textAlign: "justify"
              }}
            >
              &nbsp;
            </p>
            <ol
              start={2}
              type="i"
              className="awlist2"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "28.35pt",
                  textIndent: "-14.15pt",
                  textAlign: "justify",
                  fontWeight: "bold",
                  listStylePosition: "inside"
                }}
              >
      <span
        style={{
          width: "3.09pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;{" "}
      </span>
                <span style={{ fontWeight: "normal" }}>
        Órgãos reguladores e demais autoridades, caso seja solicitado;
      </span>
              </li>
            </ol>
            <p style={{ marginTop: "0pt", marginLeft: "36pt", marginBottom: "0pt" }}>
              &nbsp;
            </p>
            <ol
              start={3}
              type="i"
              className="awlist3"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "28.35pt",
                  marginBottom: "8pt",
                  textIndent: "-14.15pt",
                  textAlign: "justify",
                  fontWeight: "bold",
                  listStylePosition: "inside"
                }}
              >
      <span
        style={{
          width: "0.39pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                <span style={{ fontWeight: "normal" }}>&nbsp;</span>
                <span style={{ fontWeight: "normal" }}>Subcontratados como:</span>
              </li>
            </ol>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>a)</strong> - Provedores de softwares e outras tecnologias da
              informação para fins de gestão de cadastro, documentação e demais
              providências necessárias para o funcionamento da <strong>CLAP;</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>b)</strong> - Prestadores de serviços de pagamento e empresas de
              contabilidade, escritórios de advocacia;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>c)</strong> - Provedores de prevenção de fraudes e antifraude;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>d)</strong> - Provedores logísticos;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>e)</strong> - Provedores de soluções de marketing;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>f)</strong> - Provedores de gestão de prospecção comercial e
              comunicação via redes sociais;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "35.4pt",
                marginBottom: "8pt",
                textIndent: "35.4pt",
                textAlign: "justify"
              }}
            >
              <strong>g)</strong> - Provedores de atendimento ao cliente;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP</strong>utilizará seus dados pessoais apenas para as
              finalidades acima informadas, seguindo os princípios e os requisitos da
              LGPD.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>6 - TRANSFERÊNCIA INTERNACIONAL DE DADOS</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP</strong> poderá eventualmente transferir os seus Dados
              Pessoais a prestadores de serviços localizados no exterior, incluindo
              prestadores de serviços em nuvem.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Nesse caso, obrigações de proteção e segurança equivalentes às garantidas
              pela <strong>CLAP </strong>serão assumidas pelos destinatários dos dados. De
              qualquer forma, serão transferidos para o exterior apenas os dados
              necessários e serão implementadas medidas de proteção para as transferências
              de dados para outros países, por exemplo, por meio de cláusulas contratuais
              que vinculem o destinatário dos dados.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>7 - POR QUANTO TEMPO ARMAZENAMOS OS SEUS DADOS PESSOAIS?</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP </strong>armazena os seus Dados Pessoais:
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>a)</strong> - pelo tempo exigido por lei ou para o cumprimento de
              obrigação legal ou regulatória da <strong>CLAP</strong>;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>b)</strong> - até o término do tratamento de Dados Pessoais;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>c)</strong> - pelo tempo necessário para preservar o legítimo
              interesse da <strong>CLAP</strong>, a depender do caso ou
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>d)</strong> - pelo tempo necessário para resguardar o exercício
              regular de direitos em processo judicial, administrativo ou arbitral.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              O término do tratamento dos seus Dados Pessoais ocorrerá:
            </p>
            <ol
              type="a"
              className="awlist4"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "18pt",
                  textIndent: "-18pt",
                  textAlign: "justify",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.8pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                <span style={{ fontWeight: "normal" }}>
        Quando for alcançada a finalidade para a qual os seus Dados Pessoais
        tiverem sido coletados e/ou os Dados Pessoais coletados deixarem de ser
        necessários ou pertinentes para tal finalidade;
      </span>
              </li>
            </ol>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "18pt",
                marginBottom: "0pt",
                textAlign: "justify"
              }}
            >
              &nbsp;
            </p>
            <ol
              start={2}
              type="a"
              className="awlist5"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "18pt",
                  textIndent: "-18pt",
                  textAlign: "justify",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.33pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                <span style={{ fontWeight: "normal" }}>
        Quando você solicitar o término do tratamento dos seus Dados Pessoais
        pela{" "}
      </span>
                CLAP
                <span style={{ fontWeight: "normal" }}>
        , nas hipóteses em que esse tratamento ocorrer com base no seu
        consentimento ou no legítimo interesse da{" "}
      </span>
                CLAP<span style={{ fontWeight: "normal" }}> </span>
              </li>
            </ol>
            <p style={{ marginTop: "0pt", marginLeft: "36pt", marginBottom: "0pt" }}>
              &nbsp;
            </p>
            <ol
              start={3}
              type="a"
              className="awlist6"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "18pt",
                  textIndent: "-18pt",
                  textAlign: "justify",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "1.63pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                <span style={{ fontWeight: "normal" }}>
        Quando houver uma determinação legal ou uma decisão judicial, arbitral
        ou administrativa neste sentido.
      </span>
              </li>
            </ol>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "36pt",
                marginBottom: "8pt",
                textAlign: "justify"
              }}
            >
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>8 - SEUS DIREITOS ENQUANTO TITULAR DE DADOS</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Você pode exercer seus direitos em relação aos seus Dados Pessoais a
              qualquer momento e de acordo com a lei, incluindo:
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>a)</strong> - confirmar a existência de tratamento de Dados Pessoais
              pela <strong>CLAP</strong>;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>b)</strong> - acessar seus Dados Pessoais, obtendo evidências das
              finalidades perseguidas pela <strong>CLAP</strong>, as categorias de dados
              envolvidas, os destinatários com quem eles podem ser compartilhados, o
              período de armazenamento aplicável, a existência de processos automatizados
              de tomada de decisão;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>c)</strong> - atualização e retificação de Dados Pessoais
              incorretos;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>d)</strong> - solicitar a anonimização, bloqueio ou eliminação dos
              seus Dados Pessoais nos casos previstos em lei;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>e)</strong> - obter portabilidade de seus Dados Pessoais para outro
              controlador, isto é, receber os Dados Pessoais em um formato estruturado e
              legível, nas situações em que isso for exigido pela lei em vigor ou conforme
              determinado pela ANPD;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>f)</strong> - eliminar os Dados Pessoais tratados com o seu
              consentimento, nas hipóteses da lei;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>g)</strong> - poder a qualquer momento revogar o seu consentimento,
              de forma que o tratamento será encerrado imediatamente e os Dados Pessoais
              serão eliminados, salvo se a lei dispuser o contrário;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>h)</strong> - ser informado sobre as consequências no caso de
              eventual recusa no consentimento;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>i)</strong> - manifestar oposição a tratamentos de dados realizados
              em desconformidade com a LGPD.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Para exercer esses direitos, basta enviar uma solicitação à{" "}
              <strong>CLAP</strong> por e-mail para{" "}
              <span>portal-do-titular@claptickets.com.br</span>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>9 - SEGURANÇA DOS DADOS</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP </strong>adota controles para mitigar perdas e possíveis
              vazamentos de Dados Pessoais, bem como medidas de segurança e
              administrativas considerando o estado de técnica disponível, aptas a
              proteger os Dados Pessoais de acessos não autorizados e de situações
              acidentais ou ilícitas de destruição, perda, alteração, comunicação ou
              qualquer forma de tratamento inadequado ou ilícito.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP</strong> possui um plano de ação voltado para lidar com
              incidentes de segurança e para diminuir os seus impactos. Você e a
              Autoridade Nacional de Proteção de Dados serão comunicados caso ocorra algum
              incidente de segurança envolvendo os seus Dados Pessoais que acarrete risco
              ou dano relevante a Você.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP</strong> não se responsabiliza por quaisquer malwares ou
              vírus que possam afetar ou infectar seu computador e/ou outros equipamentos,
              como também pelo uso, acesso ou transferência de qualquer material deste
              Website.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>&nbsp;</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>10 - USO DE COOKIES</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A <strong>CLAP</strong> poderá utilizar cookies para fazer com que o site
              funcione, medir o tráfego no site e para publicidade.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Um “cookie” é uma pequena linha de texto que está anexada no seu browser
              quando você visita uma página de internet ou uma propaganda específica e
              pode armazenar as preferências dos USUÁRIOS e outras informações, como por
              exemplo identificar com que frequência você visitou uma página de internet
              ou uma propaganda específica.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              A utilização de cookies pela <strong>CLAP</strong> ocorre em conformidade
              com a Política de Uso de Cookies disponibilizada no nosso Website.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>11 - ALTERAÇÕES DESTA POLÍTICA DE PRIVACIDADE</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Esta Política rege a utilização do Website e de qualquer informação coletada
              a partir do mesmo. A <strong>CLAP</strong> se reserva o direito de efetuar
              mudanças nesta Política a qualquer momento, mediante a publicação de um
              aviso sobre a alteração no Website.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              As mudanças efetuadas nesta Política de Privacidade tornam-se efetivas assim
              que publicadas no Website.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>
                12 - DADOS DE CONTATO DO NOSSO ENCARREGADO PELA PROTEÇÃO DE DADOS
              </strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Se você tiver alguma pergunta, desejar fazer algum comentário, ou ainda se
              desejar eliminar seus Dados Pessoais, entre em contato com o nosso
              Encarregado, por meio do e-
              <span>mail: portal-do-titular@claptickets.com.br</span>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>13 - ACEITE OS TERMOS DA POLÍTICA DE PRIVACIDADE</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "108%",
                fontSize: "12pt"
              }}
            >
    <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
      Esta Política será regida e interpretada de acordo com as Leis
      Brasileiras, especialmente de acordo com o Marco Civil da Internet e com a
      LGPD. Fica estabelecido o foro da Comarca de{" "}
    </span>
              <strong>
                <span style={{ fontFamily: '"Calibri Light"' }}>São Paulo</span>
              </strong>
              <span style={{ lineHeight: "108%", fontSize: "11pt" }}>
      {" "}
                como competente para dirimir eventuais litígios decorrentes deste
      documento.
    </span>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Data da divulgação:{" "}
              <span>13/04/2025</span>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>SEÇÃO A – DEFINIÇÕES</strong>
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              Esta Política será regida e interpretada de acordo com as Leis Brasileiras,
              especialmente de acordo com o Marco Civil da Internet e com a LGPD. Fica
              estabelecido o foro da Comarca da <strong>CLAP</strong> como competente para
              dirimir eventuais litígios decorrentes deste documento.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "0pt", textAlign: "justify" }}>
              Caso alguma disposição específica deste instrumento venha a ser considerada
              inválida, as demais permanecerão vigentes e eficazes.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "36pt",
                marginBottom: "0pt",
                textAlign: "justify"
              }}
            >
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "0pt", textAlign: "justify" }}>
              Você, Usuário do Website concorda com os termos estabelecidos nesta
              Política?
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "36pt",
                marginBottom: "0pt",
                textAlign: "justify"
              }}
            >
              &nbsp;
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "0pt", textAlign: "justify" }}>
              A legislação de proteção de dados, especialmente a LGPD, estabelece as
              seguintes definições para os termos listados abaixo:
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "0pt", textAlign: "justify" }}>
              &nbsp;
            </p>
            <ol
              type="a"
              className="awlist7"
              style={{ margin: "0pt", paddingLeft: "0pt" }}
            >
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.8pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Controlador:{" "}
                <span style={{ fontWeight: "normal" }}>
        pessoa natural ou jurídica, de direito público ou privado, a quem
        competem as decisões referentes ao tratamento de Dados Pessoais;
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.33pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Colaborador:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  qualquer pessoa física ou jurídica, empregado, estagiário, aprendiz,
        terceirizado ou contratado, que realize ou que participe de algum
        tratamento de Dados Pessoais pela{" "}
      </span>
                CLAP
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "1.63pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Dados Pessoais:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  informações relacionadas a pessoa natural identificada ou identificável;
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  textAlign: "justify",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.33pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Encarregado:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  pessoa indicada pelo Controlador para atuar como canal de comunicação
        entre o Controlador, os Titulares dos Dados e a Autoridade Nacional de
        Proteção de Dados – ANPD. No caso da{" "}
      </span>
                CLAP
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  o Encarregado pode ser contatado por e-mail, através do endereço:{" "}
      </span>
                <span style={{ fontWeight: "normal"}}>
        portal-do-titular@claptickets.com.br
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.69pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Segurança:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  utilização de medidas técnicas e administrativas aptas a proteger os
        Dados Pessoais de acessos não autorizados e de situações acidentais ou
        ilícitas de destruição, perda, alteração, comunicação ou difusão.
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "2.75pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        &nbsp;{" "}
      </span>
                Titular de Dados:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  pessoa natural a quem se referem os Dados Pessoais que são objeto de
        tratamento.
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "1.02pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Tratamento:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  toda operação realizada com Dados Pessoais, como as que se referem a
        coleta, produção, recepção, classificação, utilização, acesso,
        reprodução, transmissão, distribuição, processamento, arquivamento,
        armazenamento, eliminação, avaliação ou controle da informação,
        modificação, comunicação, transferência, difusão ou extração.
      </span>
              </li>
              <li
                style={{
                  marginLeft: "36pt",
                  textIndent: "-18pt",
                  lineHeight: "normal",
                  fontWeight: "bold"
                }}
              >
      <span
        style={{
          width: "0.33pt",
          font: '7pt "Times New Roman"',
          display: "inline-block"
        }}
      >
        {" "}
      </span>
                Usuário:
                <span style={{ fontWeight: "normal" }}>
        {" "}
                  qualquer pessoa que de alguma forma acessa ou interage com o site,
        plataforma ou aplicativo da{" "}
      </span>
                CLAP
              </li>
            </ol>
          </>

        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;